import moment from "moment";

export const formatDateTime = (v) => moment(v).format("DD/MM/YYYY HH:mm");
